const ADMIN_BASE = '/admin';

export const PathConstants = {
  ADMIN_BASE,
  LOGIN: `${ADMIN_BASE}/login`,
  ERROR: `${ADMIN_BASE}/error`,
  HOME: `${ADMIN_BASE}/home`,
  AGREEMENTS: `${ADMIN_BASE}/agreements`,
  CATALOGUES: `${ADMIN_BASE}/catalogues`,
  CREDITS: `${ADMIN_BASE}/credits`,
  COUPON: `${ADMIN_BASE}/coupon`,
  FEEDS: `${ADMIN_BASE}/feeds`,
  FEEDBACKS: `${ADMIN_BASE}/feedbacks`,
  INVOICES: `${ADMIN_BASE}/invoices`,
  MAP: `${ADMIN_BASE}/map`,
  NOTIFICATIONS: `${ADMIN_BASE}/notifications`,
  ORDERS: `${ADMIN_BASE}/orders`,
  EVENTS: `${ADMIN_BASE}/events`,
  RESERVATIONS: `${ADMIN_BASE}/reservations`,
  REWARDS: `${ADMIN_BASE}/rewards`,
  STATISTICS: `${ADMIN_BASE}/statistics`,
  SETTINGS_EDIT_PROFILE: `${ADMIN_BASE}/settings/edit-user-profile`,
  SETTINGS_SIGNOUT: `${ADMIN_BASE}/settings/signout`,
  SETTINGS_APP_VERSIONS: `${ADMIN_BASE}/settings/app-versions`,
  SETTINGS_CHANGE_PASSWORD: `${ADMIN_BASE}/settings/change-password`,
  CLIENT_CONFIG: `${ADMIN_BASE}/tech-support/client`,
  TOPICS: `${ADMIN_BASE}/topics`,
  TICKETS: `${ADMIN_BASE}/tickets`,
  USERS: `${ADMIN_BASE}/users`,
  DELETE_ACCOUNT: `${ADMIN_BASE}/delete-account`,
  DISPATCH_CONSOLE: `${ADMIN_BASE}/dispatch`,
  VEHICLE_TYPES: `${ADMIN_BASE}/vehicle-types`,
};

export default PathConstants;
